var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5598 4.83721H6.0263C4.67508 4.83721 3.57969 5.93259 3.57969 7.28381V9.6628M17.2696 9L10.2862 16L6.80286 12.5M6.14563 21H17.8544C19.5917 21 21 19.5917 21 17.8544V6.14563C21 4.40835 19.5917 3 17.8544 3H13.674C12.857 3 12.1231 3.49612 11.8027 4.24775C11.2416 5.56444 10.3505 7.55508 9.7767 8.33721H6.14563C4.40835 8.33721 3 9.74556 3 11.4828V17.8544C3 19.5917 4.40835 21 6.14563 21Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.124dfc37a3997c253dbb4fba5951a767.svg";
export { ForwardRef as ReactComponent };